import Luiv3Constants from '@app/lui3/constants';
import FaIcon from '@app/lui3/FaIcon';
import styled from 'styled-components';

interface Props {
  title: string;
  subtitle: string;
  actionButton?: React.ReactNode;
}

const Container = styled.div`
  padding: 2.75rem 2rem 0 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

const IconContainer = styled.div`
  font-size: 1.25rem;
  line-height: 1;
  color: ${Luiv3Constants.baseColor['gray-400']};
`;

const Title = styled.div`
  font-size: 0.875rem;
  color: ${Luiv3Constants.baseColor['gray-1000']};
  font-weight: 700;
  line-height: 1.25rem;
  letter-spacing: 0.01em;
`;

const Subtitle = styled.div`
  font-size: 0.75rem;
  color: ${Luiv3Constants.baseColor['gray-600']};
  font-weight: 400;
  line-height: 1rem;
  letter-spacing: 0.02em;
  text-align: center;
`;

const EmptyState = ({title, subtitle, actionButton}: Props) => {
  return (
    <Container>
      <IconContainer>
        <FaIcon icon="envelope" size="1x" />
      </IconContainer>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
      {actionButton}
    </Container>
  );
};

export default EmptyState;
